import { inject, provideAppInitializer } from '@angular/core';
import { LanguageService } from './language.service';

export function provideTranslationInit() {
  return provideAppInitializer(() => inject(LanguageService).init());
}
